<template>
  <div class="source">
    <Search title="祖源" source="true" backurl="/home">
      <div class="box">
        <ul>
          <li class="risk-cell no_click" @click="$router.push({path: '/composition'})">
            <p class="title">主要祖源成分</p>
            <div class="right-info" >{{ main_items }}</div>
          </li>
          <li v-if="paternal_haploid !==''" class="risk-cell no_click" @click="$router.push({path: '/haplotype/father'})">
            <p class="title">父系单倍型</p>
            <div class="right-info" >{{ paternal_haploid }}</div>
          </li>
          <li v-if="maternal_haploid !== null" class="risk-cell no_click" @click="$router.push({path: '/haplotype/mother'})">
            <p class="title">母系单倍型</p>
            <div class="right-info" >{{ maternal_haploid }}</div>
          </li>
          <li class="risk-cell no_click" @click="$router.push({path: '/neanderthals'})">
            <p class="title">尼安德特人比例</p>
            <div class="right-info" >{{ neanderthal_proportion }}</div>
          </li>
        </ul>
      </div>
    </Search>
  </div>
</template>

<script>
import Search from '@/components/Search'
export default {
  name: 'index',
  data () {
    return {
      total: 4,
      main_items: '',
      paternal_haploid: '',
      maternal_haploid: '',
      neanderthal_proportion: ''
    }
  },
  methods: {
    // 祖源数据概览
    overview () {
      this.util.get(this.api.overview, '', (success) => {
        this.main_items = success.main_items
        this.paternal_haploid = success.paternal_haploid
        this.maternal_haploid = success.maternal_haploid
        this.neanderthal_proportion = success.neanderthal_proportion
      })
    }
  },
  components: {
    Search
  },
  mounted () {
    this.overview()
  }
}
</script>

<style scoped lang="scss">
  .source {
    height: 100%;
    background-color: #fff;

    .right-info {
      text-align: right;
      color: #007AFF;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/source/index.vue